import Vue from 'vue'
import App from './App.vue'

import router from '@/router'
import store from '@/store'
import { EventBus } from './eventBus'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import 'reset-css'; //清除默认样式、
import 'normalize.css'
import './assets/css/index.less';

import VueVideoPlayer from 'vue-video-player'
import framework from './components/framework.vue';
import vipRecharge from './components/vipRecharge.vue';
// 引入样式
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import { parseTime } from './utils'
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import analyticsMixin from './utils/firebase/analyticsMixin'
Vue.prototype.parseTime = parseTime

// 使用组件
Vue.use(VueVideoPlayer)

Vue.use(ElementUI);
Vue.component('framework', framework)
Vue.component('vipRecharge', vipRecharge)
Vue.mixin(analyticsMixin);
Vue.config.productionTip = false
Vue.prototype.$eventBus = EventBus
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
